import React from "react";
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function SSO() {
    const [searchParams] = useSearchParams();
    const tokenHeader = searchParams.get("token");
    const token = tokenHeader !== null ? tokenHeader : "";
    localStorage.setItem("sso-auth", token);

    const expirationDateHeader = searchParams.get("expirationDate");
    const expirationDate = expirationDateHeader !== null ? expirationDateHeader : "";
    localStorage.setItem("sso-auth-expiration-date", expirationDate);
   // const userName = searchParams.get("userName");
   
    
    const langHeader = searchParams.get("lang");
    const lang = langHeader !== null ? langHeader : "";
    localStorage.setItem("lang", lang);
    const { validateToken } = useAuth();
    React.useEffect(() => {
    validateToken(true);
    },[]);


    return <div></div>;
}

export default SSO;